@if (visible) {
  <span ngbTooltip="{{ btn.tooltipText }}" placement="bottom" class="mapbtn"
    [ngClass]="buttonClasses()">
    <span class="fa-stack">
      <i class="fal {{ btn.iconClass }} fa-stack-1x"></i>
      <i class="fal {{ btn.iconClassStacked }} fa-stack-1x stacked"></i>
    </span>
    <!-- POC: re-arrange menu <div style="font-size: 0.6em; text-align: center">{{btn.tooltipText}}</div> -->
  </span>
}